import React, { useEffect, useState } from "react";

import { Grid, Grid2 } from "@mui/material";

import { Box } from "@mui/material"; // make sure Box is imported
import BasicProjectsLeaderBoard from "./individual components/basicProjectsLeaderBoard";
import BasicUserActivityChart from "./individual components/basic2ndGraph";
import BasicChartComponent from "./individual components/basic3rdGraph";
import BasicUsersLeaderboard from "./individual components/basicUsersLeaderBoard";
import { getBasicTopUsers } from "../../../services/webServices";


function Overall() {
  const [topusers, setTopusers] = useState([]);

  const capabilityFiltering = async () => {
    try {
      const response = await getBasicTopUsers();
      const sortedCapability = [...response.data.data]
        .sort((a, b) => b.tokens_used - a.tokens_used)
        .slice(0, 16);

      setTopusers(sortedCapability);
    } catch (error) {
      console.error("Failed to get filtered capability:", error);
    }
  };

  useEffect(() => {
    // if (selectedCapability) {
    capabilityFiltering();
    // }
  }, []);

  return (
    <Box
      sx={{
        m: 3,
        height: "100%",
        overflowY: "auto",
        // height: "calc(100vh - 150px)",
        // paddingRight: "10px",
        // marginLeft: { xs: 0, md: "40px" }, // responsive left margin
      }}
    >
      <Grid container spacing={2} sx={{ mt: 3, mb: 2 }}>
        <Grid item xs={12} sm={6} md={6}>
          <BasicProjectsLeaderBoard />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <BasicUsersLeaderboard topusers={topusers} />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <BasicChartComponent />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <BasicUserActivityChart />
        </Grid>
      </Grid>
    </Box>

  );
}

export default Overall;
